var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0367 2.53125H15.6324C15.4356 2.53125 15.2487 2.62165 15.1282 2.77634L6.84537 13.269L2.87372 8.23661C2.81364 8.16033 2.73706 8.09865 2.64973 8.0562C2.56239 8.01375 2.46658 7.99164 2.36948 7.99152H0.965239C0.83064 7.99152 0.75631 8.14621 0.838676 8.25067L6.34113 15.2217C6.59827 15.5471 7.09247 15.5471 7.35162 15.2217L17.1632 2.78839C17.2456 2.68594 17.1713 2.53125 17.0367 2.53125Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.c2950291809fbf46f1bb1e2ec6c121b4.svg";
export { ForwardRef as ReactComponent };